import React from "react";
import { useUsers } from "../../../../common/CommonQueries";
import {
  CircularProgress,
  TextField,
  Box,
  makeStyles,
  Theme,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { getTheme } from "../../../../common/getLocalTheme";

const useStyles = makeStyles((theme: Theme) => ({
  autocompleteInput: {
    backgroundColor: "#ffffff",
    borderRadius: 8,
    border: "1px solid #e2e8f0",
    transition: "border-color 0.2s ease-in-out",
    "&:hover": {
      borderColor: "#cbd5e1",
    },
    "& .MuiOutlinedInput-root": {
      padding: "6px 12px !important",
      borderRadius: 8,
      "& fieldset": {
        border: "none",
      },
    },
    "& .MuiInputBase-input": {
      fontSize: "0.9rem",
      color: "#1e293b",
      fontWeight: 400,
    },
  },
}));





export const OwnerSection = ({
  owner,
  setOwner,
}:any) => {
  const classes = useStyles();
  const { data: users, isLoading: isLoadingUsers } = useUsers();

  const handleChange = (newOwner: any) => {
    if (newOwner) {
      setOwner(newOwner);
    }
  };

  if (isLoadingUsers) {
    return (
      <Box display="flex" alignItems="center" padding={1}>
        <CircularProgress size={20} />
      </Box>
    );
  }

  // Find currently selected user object
  const selectedUser =
    users?.find((user: any) => user.id === owner?.id) ||
    (owner?.username ? owner : null);

  return (
    <Autocomplete
      id="historicUser"
      options={users || []}
      getOptionLabel={(option: any) => option.username || ""}
      value={selectedUser}
      disabled={getTheme()}
      onChange={(_, newValue) => handleChange(newValue)}
      fullWidth
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Pick a user"
          variant="outlined"
          data-testid="historicUser"
          className={classes.autocompleteInput}
        />
      )}
    />
  );
};